import api from "./api"

export const getActivityLogs = async (params = {}) => {
  const response = await api.get("/activity-logs", { params })
  return response.data
}

export const getActivityLogById = async (id) => {
  const response = await api.get(`/activity-logs/${id}`)
  return response.data
}

export const getActivityLogFormData = async () => {
  const response = await api.get("/activity-logs/form-data")
  return response.data
}